/* global femcare */

femcare.footer.newsletter = {
    $form: $('#newsletterForm'),
    $title: $('.global-footer__newsletter-title'),
    $responseMessage: $('.global-footer__newsletter-response-message'),

    init: function () {
        if (this.$form.length) {
            this.$form.on('submit',
                $.proxy(function (e) {
                    e.preventDefault();

                    if (this.$form.validateForm()) {
                        femcare.tracking.gaTracking.formSubmit(this.$form);

                        $.ajax({
                            type: this.$form.attr('method'),
                            url: this.$form.attr('action'),
                            data: this.$form.serialize(),

                            success: $.proxy(function (response) {
                                if (response.success === true) {
                                    this.showResponseMessage(true);
                                } else {
                                    this.showResponseMessage(false);
                                }

                                this.$form.remove();
                            }, this),

                            error: $.proxy(function () {
                                this.$form.remove();
                                this.showResponseMessage(false);
                            }, this)
                        });
                    }
                }, this)
            );
        }
    },

    showResponseMessage: function (success) {
        var title = this.$title.attr(
            success ? 'data-response-success-title' : 'data-response-fail-title'
        );
        var message = this.$responseMessage.attr(
            success ? 'data-response-success-message' : 'data-response-fail-message'
        );
        this.$title.text(title);
        this.$responseMessage.html('<p>' + message + '</p>');
    }
};
